import { type MutationHookOptions, useMutation } from "@apollo/client";
import { DeleteRestreamDestinationMutation } from "../graphql/mutations";
import type {
  DeleteRestreamDestinationMutationType,
  DeleteRestreamDestinationMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useDeleteRestreamDestinationMutation = (
  options?: MutationHookOptions<
    DeleteRestreamDestinationMutationType,
    DeleteRestreamDestinationMutationVariablesType
  >
) => {
  return useMutation<
    DeleteRestreamDestinationMutationType,
    DeleteRestreamDestinationMutationVariablesType
  >(DeleteRestreamDestinationMutation, options);
};
